import ResourceCard from './ResourceCard';

export default ResourceCard;
